import { render, staticRenderFns } from "./InputTextDialog.vue?vue&type=template&id=5f647a36&scoped=true&"
import script from "./InputTextDialog.vue?vue&type=script&lang=js&"
export * from "./InputTextDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f647a36",
  null
  
)

export default component.exports